import React from "react";

const DeleteButton = ({handleDelete, id}) => {
    return (
    <td className="py-4 px-6 text-center">
        <button
            onClick={() => handleDelete(id)}
            className="text-red-500 hover:text-red-700 transition duration-200 ease-in-out focus:outline-none"
            aria-label="Delete Genre"
        >
            <svg
                className="h-6 w-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3m-4 0h12"
                ></path>
            </svg>
        </button>
    </td>
    )
}

export default  DeleteButton;